import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { FeatureFlagsService as ApiFeatureFlags, FeatureFlags } from 'swagger';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsManagerService {
  private featureFlags: Set<FeatureFlags> = new Set();
  private loaded = false;

  constructor(private featureFlagsApi: ApiFeatureFlags) {}

  loadFeatureFlags(): Observable<FeatureFlags[]> {
    if (this.loaded) {
      return of(Array.from(this.featureFlags));
    }

    return this.featureFlagsApi.getEnabledFeatureFlags().pipe(
      tap((flags) => {
        // API returns an array of enabled feature flag names
        this.featureFlags = new Set(flags);
        this.loaded = true;
      }),
      catchError((error) => {
        // eslint-disable-next-line no-console
        console.error('Failed to load feature flags:', error);
        // Return empty array to allow app to continue
        return of([]);
      }),
    );
  }

  isEnabled(featureFlag: FeatureFlags): boolean {
    return this.featureFlags.has(featureFlag);
  }

  getAllFlags(): FeatureFlags[] {
    return Array.from(this.featureFlags);
  }
}
